export default "__VITE_ASSET__CbiXBtup__"